<template>
  <div id="footer2015">
    <div class="footerTop">
      <div class="snsArea">
        <ul id="sns">
          <li class="sns_ttl2">
            <p>
              SNS限定のお得な情報をお届け！<i> </i>
              <i> </i>
            </p>
          </li>
          <li>
            <a
              href="https://line.me/ti/p/%40tabikobo"
              target="_blank"
              rel="noreferrer"
            >
              <img
                src="//www.tabikobo.com/images/common/ico_line.gif"
                alt="旅工房LINE"
              />
            </a>
          </li>
          <li>
            <a
              href="https://www.facebook.com/tabikobo.web/?fref=ts"
              target="_blank"
              rel="noreferrer"
            >
              <img
                src="//www.tabikobo.com/images/common/ico_facebook.gif"
                alt="旅工房facebook"
              />
            </a>
          </li>
          <li>
            <a
              href="https://twitter.com/tabikobo?lang=ja"
              target="_blank"
              rel="noreferrer"
            >
              <img class=" lazyloaded" data-src="//www.tabikobo.com/images/common/ico_x.svg" alt="旅工房X" src="//www.tabikobo.com/images/common/ico_x.svg">
            </a>
          </li>
          <li>
            <a
              href="https://www.instagram.com/tabikobo/"
              target="_blank"
              rel="noreferrer"
            >
              <img
                src="//www.tabikobo.com/images/common/ico_insta.gif"
                alt="旅工房インスタグラム"
              />
            </a>
          </li>
          <li>
            <a href="https://www.tabikobo.com/tabychan/" target="_blank" class="pr-analytics" data-pr-category="PR" data-pr-action="クリック" data-pr-label="旅工房の公式キャラクター">
              <div class="pic">
                <img class=" lazyloaded" data-src="//www.tabikobo.com/images/common/ico_tabychan.svg" alt="旅工房の公式キャラクター" src="//www.tabikobo.com/images/common/ico_tabychan.svg">
              </div>
            </a>
          </li>
        </ul>
      </div>
      <ul class="footerNav">
        <li>
          <a href="/tour/tourresult" class="arrow">ツアーを探す</a>
        </li>
        <li>
          <a href="/magazine/" class="arrow">メールマガジン</a>
        </li>
        <li>
          <a href="https://faq.tabikobo.com/?site_domain=default" class="arrow">よくある質問</a>
        </li>
      </ul>
    </div>

    <div class="areaNav">
      <h2 class="areaNavTtl"><a href="https://www.tabikobo.com/area/">海外旅行・ツアー</a></h2>
      <dl
        v-for="(area, i) in areaList"
        :key="area.title"
        class="areaNavInner"
      >
        <dt :class="{ active: areaOpen[i] }" @click="toggleArea(i)">
          <a :href="area.url">{{ area.title }}</a>
        </dt>
        <dd v-show="areaOpen[i]">
          <ul>
            <li v-for="dest in area.destinations" :key="dest.url">
              <a :href="dest.url">{{ dest.name }}</a>
            </li>
          </ul>
        </dd>
      </dl>
    </div>

    <div class="naviBox">
      <div class="naviBoxInner clearfix">
        <p>
          <a href="/">
            <img
              src="//www.tabikobo.com/images/common/f_logo.png"
              alt="TABIKOBO"
              width="154"
              height="32"
            />
          </a>
        </p>
        <ul id="infoNavi">
          <li>
            <a href="//about.tabikobo.com/">会社概要</a>
          </li>
          <li>
            <a href="//about.tabikobo.com/ir/index/">IR情報</a>
          </li>
          <li>
            <a href="//career.tabikobo.com/" target="_blank">採用情報</a>
          </li>
          <li>
            <a href="//about.tabikobo.com/csr/" target="_blank">社会的責任（CSR）</a>
          </li>
          <li>
            <a href="//about.tabikobo.com/news/press/">プレスリリース</a>
          </li>
          <li>
            <a href="//about.tabikobo.com/about/office/">支店情報</a>
          </li>
          <li>
            <a href="/form/">お問い合せ</a>
          </li>
          <li>
            <a href="/tellist/">行き先別 電話番号一覧</a>
          </li>
          <li>
            <a href="/parts/tmn/">海外旅行保険（東京海上日動）</a>
          </li>
          <li>
            <a href="/policy/yakkan/">標識、旅行業約款</a>
          </li>
          <li>
            <a href="/policy/terms/">利用規約</a>
          </li>
          <li>
            <a href="/policy/">プライバシーポリシー</a>
          </li>
          <li>
            <a href="/policy/cookie_policy/">外部送信による行動履歴情報の取得および利用に関するポリシー</a>
          </li>
          <li>
            <a href="/policy/security_policy/">情報セキュリティ基本方針</a>
          </li>
          <li>
            <a href="/sitemap/">サイトマップ</a>
          </li>
        </ul>
      </div>
    </div>

    <div id="ftMark">
      <ul id="registration">
        <li>観光庁長官登録旅行業第１６８３号（第１種）</li>
        <li>一般社団法人日本旅行業協会（ＪＡＴＡ）正会員</li>
        <li>国際航空運送協会（ＩＡＴＡ）公認代理店</li>
        <li>旅行業公正取引協議会会員</li>
      </ul>
      <ul id="association">
        <li>
          <a
            href="http://www.kotorikyo.org/"
            target="_blank"
            rel="noreferrer"
            aria-label="www.kotorikyo.org"
          >
            <img
              height="22"
              width="86"
              alt="www.kotorikyo.org"
              src="//www.tabikobo.com/images/red/share/footLinknKotori.gif"
            />
          </a>
        </li>
        <li>
          <a
            href="//www.jata-net.or.jp/"
            target="_blank"
            rel="noreferrer"
            aria-label="www.jata-net.or.jp"
          >
            <img
              height="23"
              width="23"
              alt="www.jata-net.or.jp"
              src="//www.tabikobo.com/images/red/share/jata.jpg"
            />
          </a>
        </li>
        <li>
          <a
            href="//www.iata.org/Pages/default.aspx"
            target="_blank"
            rel="noreferrer"
            aria-label="www.iata.org"
          >
            <img
              height="23"
              width="30"
              alt="www.iata.org"
              src="//www.tabikobo.com/images/red/share/footLinkIata.gif"
            />
          </a>
        </li>
        <li id="pmark">
          <a
            href="//privacymark.jp/"
            target="_blank"
            rel="noreferrer"
            aria-label="privacymark.jp"
          >
            <img
              src="//www.tabikobo.com/images/red/share/pmark.png"
              width="75"
              height="75"
              alt="プライバシーマーク"
            />
          </a>
        </li>
      </ul>
    </div>

    <div id="ftBottom">
      <div id="ftBottomDetail">
        <p id="copy">© TABIKOBO Co. Ltd. All rights reserved.</p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'TheFooter',
  data() {
    return {
      areaOpen: [],
      areaList: [
        {
          title: 'アジア',
          url: 'https://www.tabikobo.com/area/asia/',
          destinations: [
            { name: '韓国', url: 'https://www.tabikobo.com/area/asia/korea/' },
            { name: '台湾', url: 'https://www.tabikobo.com/area/asia/taiwan/' },
            { name: '香港', url: 'https://www.tabikobo.com/area/asia/hongkong/' },
            { name: 'マカオ', url: 'https://www.tabikobo.com/area/asia/macau/' },
            { name: '中国', url: 'https://www.tabikobo.com/area/asia/china/' },
            { name: 'シンガポール', url: 'https://www.tabikobo.com/area/asia/singapore/' },
            { name: 'マレーシア', url: 'https://www.tabikobo.com/area/asia/malaysia/' },
            { name: 'ブルネイ', url: 'https://www.tabikobo.com/area/asia/brunei/' },
            { name: 'タイ', url: 'https://www.tabikobo.com/area/asia/thailand/' },
            { name: 'フィリピン', url: 'https://www.tabikobo.com/area/asia/philippines/' },
            { name: 'ベトナム', url: 'https://www.tabikobo.com/area/asia/vietnam/' },
            { name: 'カンボジア', url: 'https://www.tabikobo.com/area/asia/cambodia/' },
            { name: 'ラオス', url: 'https://www.tabikobo.com/area/asia/laos/' },
            { name: 'スリランカ', url: 'https://www.tabikobo.com/area/asia/srilanka/' },
            { name: 'バリ島', url: 'https://www.tabikobo.com/area/asia/bali/' },
            { name: 'ウズベキスタン', url: 'https://www.tabikobo.com/area/asia/uzbekistan/' },
          ],
        },
        {
          title: 'ハワイ',
          url: 'https://www.tabikobo.com/area/hawaii/hawaii/',
          destinations: [
            { name: 'オアフ島', url: 'https://www.tabikobo.com/area/hawaii/oahu/' },
            { name: 'ハワイ島', url: 'https://www.tabikobo.com/area/hawaii/hawaii-2/' },
          ],
        },
        {
          title: '南太平洋',
          url: 'https://www.tabikobo.com/area/southpacific/',
          destinations: [
            { name: 'フィジー', url: 'https://www.tabikobo.com/area/southpacific/fiji/' },
          ],
        },
        {
          title: 'オセアニア',
          url: 'https://www.tabikobo.com/area/oceania/',
          destinations: [
            { name: 'オーストラリア', url: 'https://www.tabikobo.com/area/oceania/australia/' },
            { name: 'ニュージーランド', url: 'https://www.tabikobo.com/area/oceania/newzealand/' },
          ],
        },
        {
          title: 'ヨーロッパ',
          url: 'https://www.tabikobo.com/area/europe/',
          destinations: [
            { name: 'イタリア', url: 'https://www.tabikobo.com/area/europe/italy/' },
            { name: 'スペイン', url: 'https://www.tabikobo.com/area/europe/spain/' },
            { name: 'フランス', url: 'https://www.tabikobo.com/area/europe/france/' },
            { name: 'イギリス', url: 'https://www.tabikobo.com/area/europe/uk/' },
            { name: 'アイルランド', url: 'https://www.tabikobo.com/area/europe/ireland/' },
            { name: 'ベルギー', url: 'https://www.tabikobo.com/area/europe/belgium/' },
            { name: 'ドイツ', url: 'https://www.tabikobo.com/area/europe/germany/' },
            { name: 'オランダ', url: 'https://www.tabikobo.com/area/europe/netherlands/' },
            { name: 'ギリシャ', url: 'https://www.tabikobo.com/area/europe/greece/' },
            { name: 'ハンガリー', url: 'https://www.tabikobo.com/area/europe/hungary/' },
            { name: 'チェコ', url: 'https://www.tabikobo.com/area/europe/czech/' },
            { name: 'オーストリア', url: 'https://www.tabikobo.com/area/europe/austria/' },
            { name: 'マルタ', url: 'https://www.tabikobo.com/area/europe/malta/' },
            { name: 'モナコ', url: 'https://www.tabikobo.com/area/europe/monaco/' },
            { name: 'ポルトガル', url: 'https://www.tabikobo.com/area/europe/portugal/' },
            { name: 'クロアチア', url: 'https://www.tabikobo.com/area/europe/croatia/' },
            { name: 'スイス', url: 'https://www.tabikobo.com/area/europe/switzerland/' },
            { name: 'バルト三国', url: 'https://www.tabikobo.com/area/europe/baltic_states/' },
            { name: 'ポーランド', url: 'https://www.tabikobo.com/area/europe/poland/' },
          ],
        },
        {
          title: '北欧',
          url: 'https://www.tabikobo.com/area/nordic/',
          destinations: [
            { name: 'フィンランド', url: 'https://www.tabikobo.com/area/nordic/finland/' },
            { name: 'ノルウェー', url: 'https://www.tabikobo.com/area/nordic/norway/' },
            { name: 'デンマーク', url: 'https://www.tabikobo.com/area/nordic/denmark/' },
            { name: 'スウェーデン', url: 'https://www.tabikobo.com/area/nordic/sweden/' },
            { name: 'アイスランド', url: 'https://www.tabikobo.com/area/nordic/iceland/' },
          ],
        },
        {
          title: '北アメリカ',
          url: 'https://www.tabikobo.com/area/northamerica/',
          destinations: [
            { name: 'アメリカ', url: 'https://www.tabikobo.com/area/northamerica/usa/' },
            { name: 'カナダ', url: 'https://www.tabikobo.com/area/northamerica/canada/' },
          ],
        },
        {
          title: '中近東',
          url: 'https://www.tabikobo.com/area/middleeast/',
          destinations: [
            { name: 'トルコ', url: 'https://www.tabikobo.com/area/middleeast/turkey/' },
            { name: 'アラブ首長国連邦', url: 'https://www.tabikobo.com/area/middleeast/uae/' },
            { name: 'エジプト', url: 'https://www.tabikobo.com/area/middleeast/egypt/' },
            { name: 'モロッコ', url: 'https://www.tabikobo.com/area/middleeast/morocco/' },
          ],
        },
      ],
      isMobile: false,
    }
  },
  mounted() {
    this.checkMobile()
    window.addEventListener('resize', this.checkMobile)
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.checkMobile)
  },
  methods: {
    toggleArea(i) {
      if (!this.isMobile) return
      this.$set(this.areaOpen, i, !this.areaOpen[i])
    },
    checkMobile() {
      this.isMobile = window.innerWidth <= 657
      // PCは全て開く、スマホは初期状態で全て閉じる
      this.areaOpen = this.areaList.map(() => !this.isMobile)
    },
  },
}
</script>
